import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var sanitisePathSegment = function(text) {
    return text ? text.replace(/\s+/g, "-").replace(/\[/g, "(").replace(/]/g, ")").toLowerCase() : "";
};
export var productDetailUrl = function(vehicle) {
    if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
        return "/used-cars";
    }
    return "/used-cars/".concat(sanitisePathSegment(vehicle.make), "/").concat(sanitisePathSegment(vehicle.model), "/details/").concat(vehicle.id);
};
export var LinkToProductDetail = function(param) {
    var children = param.children, basicVehicleInfo = param.basicVehicleInfo, className = param.className;
    return /*#__PURE__*/ _jsx("a", {
        href: productDetailUrl(basicVehicleInfo),
        target: "_blank",
        "aria-label": "Open the car detail page in a new browser tab",
        rel: "noreferrer",
        className: className,
        children: children
    });
};
